import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {
  brandsList = [
    {
      name: 'tobank',
      title: 'سوپر اپلیکیشن توبانک',
      description:
        'توبانک یکی از محصولات شرکت دانش‌بنیان ایپام است که پس از کسب مجوز «پرداخت‌یاری» از بانک مرکزی جمهوری اسلامی و شاپرک به ارائه خدمات متنوع پرداخت می‌پردازد. امنیت، سرعت، سادگی، تجربه کاربری منحصربه‌فرد، پوشش طیف گسترده‌ای از خدمات متنوع، بی‌نیازی از بسترهای مختلف دیگر و قابل اعتماد بودن، تمام آن چیزی است که مصرف‌کنندگان یک بستر خدماتی در حوزه مالی به آن نیاز دارند. با توبانک نیاز به جابه‌جایی‌ها و به‌کارگیری روش‌های سنتی برای هرگونه پرداخت اعم از نقل و انتقال پول و سرمایه‌گذاری، برطرف می‌شود.',
      bannerImg: 'assets/tobank-banner.png',
      color: '',
      btnTxt: 'ورود به توبانک',
      btnLink: 'https://tobank.ir'
    },
    {
      name: 'pardakhtbani',
      title: 'پرداخت‌بانی ',
      description:
        'گردش‌پی به عنوان شخصیت حقوقی موفق به کسب مجوز «پرداخت‌بانی» نیز شده است. با استفاده از کیف پول الکترونیکی می‌توان تراکنش‌های خُرد اینترنتی مانند انواع خرید آنلاین، پرداخت قبض‌های متنوع و هزینه استفاده از وسایل حمل و نقل عمومی را انجام داد.\n' +
        'با داشتن کیف پول الکترونیکی دیگر نیازی به حمل پول نقد و کارت‌های بانکی نیست. برای انتقال وجه، تکمیل اطلاعات صفحه پرداخت آنلاین ضرورت ندارد. با دسترسی به تمام حساب‌های خود، نگرانی از مخاطرات احتمالی و کمبود زمان جایی ندارد.\n',
      bannerImg: 'assets/pardakhtbani-banner.png',
      color: '',
      btnTxt: 'ورود به سایت پرداخت‌بانی ',
      btnLink: 'https://gardeshpay.ir/'
    },
    {
      name: 'pardakhtsazi',
      title: 'پرداخت‌سازی',
      description:
        'بانکداری باز دسترسی به اطلاعات مشتریان (با کسب رضایت آنها) را میسر می‌سازد. در پی رشد فناوری، ضمن بازتعریف نوع نگرش نسبت به مالکیت اطلاعات کاربران، بانکداری باز با انتشار PSD2، اطلاعات بانکی مشتریان را از طریق  APIهای عمومی در دسترس استارت‌آپ‌ها و توسعه‌دهندگان خدمات قرار می‌دهد تا به این ترتیب امکان عرضه خدمات در قالب طرح‌های نوین در حوزه فین‌تک برای آنان فراهم شود.\n' +
        'سامانه‌های بانکداری باز خدماتی همچون تحلیل مخارج، برنامه‌ریزی بودجه و تنظیم رفتارهای اقتصادی را ارائه می‌دهند ولی امکان ارائه خدمات بانکی مانند افتتاح حساب یا دریافت وام‌های مرسوم را ندارند. این اپلیکیشن‌ها بینش‌های ارزشمندی را در مورد وضعیت مالی فعلی کاربران ارائه می‌دهند. این فرآیند با بهره‌مندی از امکانات پرطرفداری مانند رتبه‌بندی امتیاز اعتباری، وام P2P و دریافت اطلاعات از چندین حساب مالی، تجربه کاربری ویژه‌ای را سبب می‌شود.\n' +
        'اگر شما قصد راه‌اندازی اپلیکیشن مدیریت مالی را دارید، نیازی به ارتباط مستقیم با یک یا چند بانک مختلف نیست. امروزه اکثر ارائه‌دهندگان بستر بانکداری باز به سیستم‌های بانکداری متصل هستند و توسعه‌دهندگان فعال می‌توانند با چند خط کد، از اطلاعات مورد نیاز در اپلیکیشن خود استفاده کنند. به لطف بانکداری باز، استارت‌آپ‌ها تقریبا قادر به اجرای هر نوع ایده‌ای که نیازمند استفاده از داده‌های مالی خاص باشد، هستند.\n',
      bannerImg: 'assets/pardakhtsazi-banner.png',
      color: '',
      btnTxt: 'ورود به پرداخت‌سازی',
      btnLink: 'https://pardakhtsazi.ir/'
    },
    {
      name: 'pardakhtyari',
      title: 'پرداخت‌یاری گردش پی',
      description:
        'ایپام همگام با ارائه خدمات فنی زیرساخت‌های پرداخت الکترونیک، نسبت به توسعه پلتفرم‌های پرداخت‌یاری و اخذ مجوزهای لازم از بانک مرکزی جمهوری اسلامی و شاپرک اقدام نموده است تا با کیفیت و سرعت بیشتر، نسبت به ارائه خدمات پرداخت آنلاین به مشتریان خود اقدام کند.',
      bannerImg: 'assets/pardakhtyari-banner.png',
      color: '',
      btnTxt: 'ورود به گردش پی',
      btnLink: 'https://gardeshpay.ir/'
    },
    {
      name: 'hotelsys',
      title: 'هتل‌سیس',
      description:
        'یک ساختار یکپارچه، سریع و امن برای ارتباطی نوین و مدیریت بین مهمانان و هتل است. این نرم‌افزار علاوه بر همگام‌سازی و اتوماسیون خدمات قبل، بعد و حین اقامت مهمان در هتل، امکانات جدیدی شامل: ثبت، دریافت، پردازش سفارش‌ها، سرگرمی و Guest relationship management را برای مهمانان و مدیریت هتل فراهم می‌کند.',
      bannerImg: 'assets/hotelsys-banner.png',
      color: '',
      btnTxt: 'ورود به هتل سیس',
      btnLink: 'https://hotelsys.ir/'
    }
  ];
  brandSelected: any;

  constructor(private activeRoute: ActivatedRoute, private router: Router) {
    activeRoute.params.subscribe((param: Params) => {
      this.brandSelected = this.brandsList.find((a) => a.name === param.name);
      if (!this.brandSelected) {
        this.router.navigate(['/']);
      }
    });
  }

  ngOnInit(): void {}

  showSite(btnLink: string) {
    window.open(btnLink, '_blank');
  }
}
